import React, { Component } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../../Context";
import {
  GetListings,
  TranslateListing,
  GetDateFromMilliseconds,
  UpdateFav
} from "../../utils/consts";

import MyTable from "../../components/myTable/MyTable";

import TrashIcon from "@atlaskit/icon/glyph/trash";

export default class FavsTable extends Component {
  state = {
    start: 0,
    volume: 10
  };

  componentDidMount() {
    this.getListings();
  }

  getListings = async () => {
    this.setState({ loading: true });
    const favs = this.props.favs || {};
    Object.keys(favs).map(
      lid => (favs[lid] = GetDateFromMilliseconds(favs[lid]))
    );
    const favesArr = Object.keys(favs);
    // const { start, volume } = this.state;
    // const currentFaves = favesArr.filter((lid, i) => i < start + volume);
    const currentFaves = favesArr;
    const listingPromises = currentFaves.map(lid =>
      GetListings(lid)
        .then(listings => listings[lid])
        .catch(err => console.log(err))
    );
    const untranslated = await Promise.all(listingPromises);
    const translated = await untranslated.map(listing =>
      TranslateListing(listing)
    );
    const listingsArr = await Promise.all(translated);
    let listings = {};
    listingsArr.forEach(listing => {
      listings[listing.lid] = listing;
    });
    this.setState({ listings, loading: false });
  };

  updateFav = (uid, lid, add) => {
    UpdateFav(uid, lid, add)
      .then(result =>
        this.props.addFlag({
          appearance: 2,
          title: result
        })
      )
      .catch(error => {
        this.props.addFlag({
          appearance: 2,
          title: "Error - Please Try Again"
        });
      });
  };

  render() {
    console.log(this.state);
    return (
      <UserContext.Consumer>
        {userContext => {
          const my = userContext.my || {};
          const favs = my.favs || {};
          console.log(favs);
          const listings = this.state.listings || [];
          const user = userContext.user || {};
          return (
            <div className="favs-table">
              <MyTable
                onSort={e => console.log(e)}
                onSetPage={e => console.log(e)}
                page={1}
                caption="Favs"
                head={{
                  cells: [
                    {
                      key: "title",
                      content: (
                        <span className="my__table-header-cell">Title</span>
                      ),
                      isSortable: true,
                      width: 50,
                      shouldTruncate: true
                    },
                    {
                      key: "date",
                      content: (
                        <span className="my__table-header-cell">Date</span>
                      ),
                      isSortable: true,
                      width: 30,
                      shouldTruncate: true
                    },
                    {
                      key: "delete",
                      content: (
                        <span className="my__table-header-cell">Delete</span>
                      ),
                      width: 20,
                      shouldTruncate: true
                    }
                  ]
                }}
                rows={Object.keys(listings)
                  .filter(lid => !!favs[lid])
                  .map(lid => listings[lid])
                  .map((listing, i) => {
                    return {
                      cells: [
                        {
                          key: `fav-row__${i}_name`,
                          content: (
                            <Link
                              className="table-row-link"
                              to={`/listing/${listing.lid}`}
                            >
                              {listing.title}
                            </Link>
                          )
                        },
                        {
                          key: `fav-row__${i}_name`,
                          content: (
                            <Link
                              className="table-row-link"
                              to={`/listing/${listing.lid}`}
                            >
                              {GetDateFromMilliseconds(favs[listing.lid])}
                            </Link>
                          )
                        },
                        {
                          key: `fav-row__${i}_delete`,
                          content: (
                            <TrashIcon
                              onClick={() =>
                                this.updateFav(user.uid, listing.lid, false)
                              }
                            />
                          )
                        }
                      ],
                      key: `lid__row_${i}`
                    };
                  })}
                emptyView={<span>No Listings Favourited</span>}
                loading={userContext.myLoading || this.state.loading}
              />
            </div>
          );
        }}
      </UserContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FavsTable/FavsTable.js